export default __webpack_public_path__ + "static/media/V A S A.82a50fde.png";